<template>
    <div
    class="dropdown-menu container"
    :class="{ shown: isHover || isHoverOuter}"
    :aria-hidden="isHover || isHoverOuter"
    :style="'width: ' + ((links.length ? 20 : 0) + texts.length * 20) + 'rem'"
    @mouseleave="isHover = false"
    >
        <div class="row">
          <div v-if="links.length" class="col-sm">
            <div v-for="(el, i) in links" :key="'nav-link-' + i">
                <CTFLink
                  v-if="el.sys.contentType.sys.id == 'button'"
                  :btn-id="el.sys.id"
                  :margin="false"
                  class="ctf-nav-link"
                  nav-link
                />

                <!-- Leaving this commented out as I don't know if this will be a requirement in the furture -->

                <!-- <icon-tile
                  v-if="el.sys.contentType.sys.id == 'iconTile'"
                  :fields="el.fields"
                  :btnId="el.fields.button ? el.fields.button.sys.id : null"
                /> -->
            </div>
          </div>
          <div class="col-sm" v-for="(el, i) in texts" :key="'text-box-' + i">
            <ctf-rich-text
                  v-if="el.sys.contentType.sys.id == 'richText'"
                  :document="el.fields.content"
                  class="ctf-nav-link"
                  nav-link
                />
          </div>
        </div>
        <div class="sr-only" @click="close()">
            <input type="button" value="" @focus="close()">
        </div>
        <div class="bounding" @mouseleave="isHoverOuter = false" @mouseenter="isHoverOuter = true"> </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { queryEntryCTF } from '@/plugins/contentful'

export default {
  name: 'Submenu',
  components: {
    CTFLink: () => import('@/components/snippets/ctf-link'),
    CtfRichText: () => import('../snippets/ctf-rich-text/ctf-rich-text.vue')
    // IconTile: () => import('../slices/icon-tiles/icon-tile.vue')
  },
  async created () {
    this.ctfData = await Promise.all(this.content.map(x => queryEntryCTF(x.sys.id)))
    this.links = this.ctfData.filter(x => x.sys.contentType.sys.id === 'button')
    this.texts = this.ctfData.filter(x => x.sys.contentType.sys.id === 'richText')
  },
  data () {
    return {
      ctfData: [],
      links: [],
      texts: [],
      isHover: false,
      isHoverOuter: false
    }
  },
  computed: {
    ...mapState('site', ['siteConfig', 'configAssets']),
    ...mapState('layout', ['pageLastUpdatedDate'])
  },
  props: {
    content: {
      type: Array,
      default: function () { return [] }
    },
    linkHover: {
      type: Boolean,
      default: false
    },
    activeMenu: {
      type: Array,
      default: null
    }
  },
  watch: {
    linkHover: function (newVal, oldVal) {
      if (newVal) {
        const _this = this
        _this.$emit('open-dropdown', _this.ctfData)
        this.isHover = true
      }
      setTimeout(function () {
        if (!this.isHoverOuter) {
          this.isHover = false
        }
      })
    },
    activeMenu (newVal, oldVal) {
      if (newVal !== this.ctfData) {
        this.close()
      }
    }
  },
  methods: {
    navigateSocial (link, tracking) {
      if (this.$analytics && tracking) {
        this.$analytics.track(tracking)
      }
      window.open(link, '_blank')
    },
    close () {
      this.isHover = false
      this.isHoverOuter = false
    },
    openDropdown (model) {
      if (this !== model) {
        this.isHover = false
        this.isHoverOuter = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/styles/variables";

div {
  z-index: 2;
}

.dropdown-menu {
    position: absolute;
    border-top: 4px solid $primary;
    box-shadow: 1px 2px 4px #00000075;
    background: white;
    padding: 20px;
    opacity: 0;
    transition: .1s;
    pointer-events: none;
    visibility: hidden;
}

.dropdown-menu.shown {
    opacity: 1;
    display: block;
    pointer-events: all;
    visibility: visible;
}

.bounding {
    position: absolute;
    top:-60px;
    left:-20px;
    right:-20px;
    bottom:-20px;
    z-index: 1;
}

.image-wrapper {
  img {
    max-width: 100%;
    display: block;
    min-width: 291px;
    max-width: 291px;
    min-height: 88px;
    max-height: 88px;
    object-fit: contain;
  }
}

.zld {
  z-index: 201;
}

</style>
